import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";

import { AddressComponent } from "./address/address.component";
import { LegendItemDirective } from "./legend/legend-item.component";
import { LegendComponent } from "./legend/legend.component";
import { ReporterComponent } from "./reporter/reporter.component";
import { TitleComponent } from "./title/title.component";
import { ButtonModule } from "../button/button.module";
import { InputModule } from "../input";

@NgModule({
	imports: [CommonModule, InputModule, ButtonModule, MatTooltipModule],
	declarations: [TitleComponent, AddressComponent, LegendComponent, LegendItemDirective, ReporterComponent],
	exports: [TitleComponent, AddressComponent, LegendComponent, LegendItemDirective, ReporterComponent],
})
export class TextModule {}
